import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigStateService } from '../config/config-state.service';

@Injectable()
export class EncodeJsonInterceptor implements HttpInterceptor {

  constructor(private config: ConfigStateService) { }

  // Typescript solution from https://stackoverflow.com/questions/30106476/using-javascripts-atob-to-decode-base64-doesnt-properly-decode-utf-8-strings
  b64EncodeUnicode(str) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
      return String.fromCharCode(parseInt(p1, 16))
    }))
  }

  intercept(req: HttpRequest<any>, next: HttpHandler):
    Observable<HttpEvent<any>> {
      if (this.config.featureFlags.encodeJsonPutPostRequest) {
        if (req.method.toUpperCase() === 'POST' || req.method.toUpperCase() === 'PUT') {
          const isFormData = req.body instanceof FormData;
          if (req.body && !isFormData && req.headers.get('Accept') === 'application/json' && !req.body['encoded']) {
            const encoded = { encoded: true };
            for (const key of Object.keys(req.body)) {
              if (key !== "id") {
                encoded[key] = this.b64EncodeUnicode(JSON.stringify(req.body[key]));
              }
            }
            const encodedReq = req.clone({ 
              body: { ...req.body, ...encoded },
            });
            return next.handle(encodedReq);
          }
        }
      }
      return next.handle(req);
  }
}